/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {EventTransport} from './EventTransport';
import {EventType} from './EventType';
import {CustomerNotificationSetting} from './CustomerNotificationSetting';
import {ManagerNotificationSetting} from './ManagerNotificationSetting';
import {EventTemplateDto} from './EventTemplateDto';

export interface NotificationSettings {
  eventTransport: EventTransport[];
  eventType: EventType[];
  notificationSettings: CustomerNotificationSetting[] | ManagerNotificationSetting[];
  eventTemplates: EventTemplateDto[]
}
